// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accordeon generique de la page Analyse (Reception des plis / Decryptage / Analyse).
   L'entete reutilise la classe globale .section-header (onglet Questions/reponses) :
   fond #595959, padding 1rem, texte 2rem. Ce fichier n'ajoute que la mise en page
   flex (titre + chevron), l'etat verrouille et le corps replie/deplie. */

.analyse-accordion {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 1rem;
  background: #fff;
}

.analyse-accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.analyse-accordion-title {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.analyse-accordion-lock {
  flex-shrink: 0;
  opacity: 0.85;
}

.analyse-accordion-hint {
  font-size: 1rem;
  font-weight: 400;
  font-style: italic;
  opacity: 0.85;
}

.analyse-accordion-chevron {
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.analyse-accordion-chevron.open {
  transform: rotate(180deg);
}

.analyse-accordion-body {
  padding: 1.2rem;
}

/* Section verrouillee : entete grisee (specificite > .section-header), curseur interdit */
.analyse-accordion--locked .analyse-accordion-header {
  background-color: #9ca3af;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/composants/AnalyseAccordion/AnalyseAccordion.css"],"names":[],"mappings":"AAAA;;;yEAGyE;;AAEzE;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,0FAA0F;AAC1F;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":["/* Accordeon generique de la page Analyse (Reception des plis / Decryptage / Analyse).\n   L'entete reutilise la classe globale .section-header (onglet Questions/reponses) :\n   fond #595959, padding 1rem, texte 2rem. Ce fichier n'ajoute que la mise en page\n   flex (titre + chevron), l'etat verrouille et le corps replie/deplie. */\n\n.analyse-accordion {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 1rem;\n  background: #fff;\n}\n\n.analyse-accordion-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n.analyse-accordion-title {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.analyse-accordion-lock {\n  flex-shrink: 0;\n  opacity: 0.85;\n}\n\n.analyse-accordion-hint {\n  font-size: 1rem;\n  font-weight: 400;\n  font-style: italic;\n  opacity: 0.85;\n}\n\n.analyse-accordion-chevron {\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.analyse-accordion-chevron.open {\n  transform: rotate(180deg);\n}\n\n.analyse-accordion-body {\n  padding: 1.2rem;\n}\n\n/* Section verrouillee : entete grisee (specificite > .section-header), curseur interdit */\n.analyse-accordion--locked .analyse-accordion-header {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
